import React, {useContext} from "react";
import LocalizationSelect from "../../../components/LocalizationSelect/LocalizationSelect";
import {Trans, useTranslation} from "react-i18next";
import s from "../styles/login.module.css";
import UISettingsContext from "../../../utils/UISettingsContext";
import {Typography} from "antd";

export const Footer = () => {
  const {t} = useTranslation(["loginPage", "static"]);
  const {supportUrl} = useContext(UISettingsContext);

  return (
    <div className={s.footer}>
      <LocalizationSelect className={s.info__select}/>
      <div className={s.font__gray}>
        <span className={`${s.font__small} ${s.font__blue}`}>{t("troubleLoggingIn")}</span>
        <br/>
        <Trans
              i18nKey="contactTechnicalSupportWithLink"
              ns="common"
              components={{
                "linkToSupport": (
                  <Typography.Link href={supportUrl} target="_blank" rel="noopener noreferrer"/>
                )
              }}
        />
      </div>
    </div>
  );
};
